import { useState } from 'react'
import { Link } from '@tanstack/react-router'

interface RecoveryBody {
  pin?: string
  message?: string
}

export function ForgotPinPage() {
  const [email, setEmail] = useState('')
  const [dateOfBirth, setDateOfBirth] = useState('')
  const [pin, setPin] = useState('')
  const [message, setMessage] = useState('')
  const [busy, setBusy] = useState(false)

  async function submit(event: React.FormEvent) {
    event.preventDefault()
    setBusy(true)
    setMessage('')
    setPin('')
    try {
      const res = await fetch('/api/pin-recovery', {
        method: 'POST',
        credentials: 'include',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ email, dateOfBirth }),
      })
      const body = (await res.json().catch(() => ({}))) as RecoveryBody
      if (res.ok && body.pin) {
        setPin(body.pin)
      } else {
        setMessage(body.message ?? "Couldn't verify your details. Contact an admin.")
      }
    } catch {
      setMessage('Unable to reach the server. Please try again.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="app-layout">
      <main className="app-main centered-page">
        <form className="card auth-form" onSubmit={submit}>
          <h1>Forgot your PIN?</h1>
          <p className="muted">Enter the details held by the club.</p>
          <label>
            Email
            <input
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          </label>
          <label>
            Date of birth
            <input
              type="date"
              required
              value={dateOfBirth}
              onChange={(event) => setDateOfBirth(event.target.value)}
            />
          </label>
          <button className="btn" type="submit" disabled={busy}>
            {busy ? 'Checking…' : 'Recover PIN'}
          </button>

          {pin ? (
            <div className="recovered-pin" role="status">
              <span>Your PIN is</span>
              <strong>{pin}</strong>
              <span>Save this—you’ll need it to log in.</span>
            </div>
          ) : null}
          {message ? <p className="error">{message}</p> : null}
          <Link to="/login" className="text-link center">Return to login</Link>
        </form>
      </main>
    </div>
  )
}
